import { faSparkle } from "@fortawesome/pro-solid-svg-icons";
import { Chip, Typography } from "@mui/material";
import { useEventCallback } from "usehooks-ts";

import { Icon } from "@/components/ui-v2/Icon/Icon";

import { DisabledArea } from "../DisabledArea/DisabledArea";
import { Link } from "../Link/Link";
import { MenuItem } from "../Menu/components/MenuItem";
import {
  bindMenu,
  bindMenuTrigger,
  useMenuState,
} from "../Menu/hooks/useMenuState";
import { DataMenu } from "./DataMenu";
import { MenuItemData } from "./types";

/**
 * @deprecated Use Menu/MenuItems instead
 */
interface DataMenuItemProps {
  data: MenuItemData;
  onCloseMenu?: () => void;
}

const DataMenuItemWithSubMenu = ({ data, onCloseMenu }: DataMenuItemProps) => {
  const subMenuState = useMenuState({
    openOnClick: true,
    useDefaultOrigins: true,
  });
  return [
    <MenuItem
      key="item"
      data-actionid={data.id}
      data-actiontype="submenu"
      {...bindMenuTrigger(subMenuState)}
      hasSubMenu
      icon={data.icon}
      disabled={data.disabled}
      selected={data.selected}
    >
      {data.name}
    </MenuItem>,
    <DataMenu
      key="submenu"
      data-testid={`submenu-${data.id?.toLowerCase()}`}
      data-actiontype="item"
      {...bindMenu(subMenuState)}
      items={data.subMenu ?? []}
      onCloseMenu={onCloseMenu}
    />,
  ];
};

export const DataMenuItem = (props: DataMenuItemProps) => {
  const { data, onCloseMenu } = props;

  const onClick = useEventCallback(() => {
    data.onClick?.();

    if (data.closeOnClick) onCloseMenu?.();
  });

  return data.subMenu ? (
    <DataMenuItemWithSubMenu data={data} onCloseMenu={onCloseMenu} />
  ) : (
    <DisabledArea
      disabled={data.disabled}
      title={data.disabledTooltipTitle}
      arrow={false}
      placement="bottom"
    >
      <MenuItem
        data-actionid={data.id}
        data-actiontype="item"
        component={data.route ? Link : undefined}
        href={data.route || undefined}
        icon={data.icon}
        selected={data.selected}
        onClick={onClick}
        disabled={data.disabled}
        endIcon={
          data.featured ? (
            <Chip
              label="Featured"
              variant="filled"
              color="success"
              size="small"
              icon={<Icon icon={faSparkle} />}
              sx={{
                fontSize: 10,
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            />
          ) : undefined
        }
      >
        <Typography>{data.name}</Typography>
      </MenuItem>
    </DisabledArea>
  );
};
